<div class="plain-container-row">
  <ng-container *ngFor="let img of gallery; let i = index">
    <div *ngIf="i <= maxItems">
      <a class="more" *ngIf="i == maxItems" (click)="openGallery(img)"> +{{ images.length - maxItems - 1 }}</a>
      <img
        *ngIf="img.plain && img.plain.img; else noThumb"
        class="image-row"
        [src]="img.plain.img"
        (click)="openGallery(img)" />

      <ng-template #noThumb>
        <img class="image-row" [src]="img.modal.img" (click)="openGallery(img)" />
      </ng-template>
    </div>
  </ng-container>
</div>

<ks-plain-gallery [id]="1" [images]="gallery" (clickImage)="showModalGallery(1, $event)"> </ks-plain-gallery>
